import { useEffect, useState } from "react";

interface DetailActionsProps {
  title: string;
  favorite: boolean;
  onToggleFavorite: () => void;
}

export default function DetailActions({ title, favorite, onToggleFavorite }: DetailActionsProps) {
  const [toast, setToast] = useState("");
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制，快去分享吧");
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
    }
    setShareOpen(false);
  };

  const shareTo = (platform: string, href: string) => {
    window.open(href, "_blank", "noopener,noreferrer");
    setToast(`已打开${platform}分享页`);
    setShareOpen(false);
  };

  const url = encodeURIComponent(window.location.href);
  const text = encodeURIComponent(`${title} - 黑人文化资讯`);

  return (
    <div className="relative">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setShareOpen((v) => !v)}
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-share-forward-line" />
          分享
        </button>
        <button
          type="button"
          onClick={onToggleFavorite}
          className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-md border text-sm transition-colors cursor-pointer whitespace-nowrap ${
            favorite
              ? "bg-accent-500 border-accent-500 text-secondary-950"
              : "border-background-300 text-foreground-700 hover:bg-background-100"
          }`}
        >
          <i className={favorite ? "ri-bookmark-fill" : "ri-bookmark-line"} />
          {favorite ? "已收藏" : "收藏"}
        </button>
      </div>

      {shareOpen && (
        <div className="absolute right-0 top-full mt-2 z-30 w-56 bg-background-50 rounded-lg border border-background-200 shadow-sm overflow-hidden animate-soft-in">
          <button
            type="button"
            onClick={copyLink}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer text-left"
          >
            <i className="ri-link" />
            复制链接
          </button>
          <button
            type="button"
            onClick={() => shareTo("微博", `https://service.weibo.com/share/share.php?url=${url}&title=${text}`)}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer text-left"
          >
            <i className="ri-weibo-fill" />
            分享到微博
          </button>
          <button
            type="button"
            onClick={() => shareTo("X", `https://twitter.com/intent/tweet?url=${url}&text=${text}`)}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer text-left"
          >
            <i className="ri-twitter-x-fill" />
            分享到 X
          </button>
        </div>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[60] px-5 py-3 rounded-md bg-foreground-900 text-background-50 text-sm animate-soft-in whitespace-nowrap">
          {toast}
        </div>
      )}
    </div>
  );
}